/**
 * Edit Lead Profile
 */

import React, { useState } from "react";
import { Box, Stepper, Step, StepButton } from "@mui/material";

import NewLeadProfile from "../NewLeadProfile";
import StoreVisit from "../StoreVisit";
import DocVerification from "../DocVerification";
import Approvals from "../Approvals";
import Qualified from "../Qualified";
import Converted from "../Converted";

import { CRM_LEAD_STATUS } from "common/config";

interface defaultProps {
  selectedRow;
}

const EditLeadProfile = (props: any) => {
  const { selectedRow, areas, onClose } = props;
  let steps = [
    CRM_LEAD_STATUS.NEW_LEAD,
    CRM_LEAD_STATUS.VERIFIED,
    CRM_LEAD_STATUS.ASSIGNED,
    CRM_LEAD_STATUS.STORE_VISIT,
    CRM_LEAD_STATUS.DOCUMENT_VERIFICATION,
    CRM_LEAD_STATUS.APPROVALS,
    CRM_LEAD_STATUS.QUALIFIED,
    CRM_LEAD_STATUS.CONVERTED,
  ];
  let nextStep = 0;
  if (selectedRow.crmLeadStatus === CRM_LEAD_STATUS.NEW_LEAD) {
    steps = [CRM_LEAD_STATUS.NEW_LEAD];
  } else {
    nextStep = steps.indexOf(selectedRow.crmLeadStatus) + 1;
    if (nextStep >= steps.length) {
      nextStep = steps.length - 1;
    }
  }
  const [activeStep, setActiveStep] = useState(nextStep);
  const [completed, setCompleted] = useState<{ [k: number]: boolean }>({});

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step: number) => () => {
    // setTabs("TAB " + { step });
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  console.log("edit: ", selectedRow, activeStep);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Stepper nonLinear activeStep={activeStep}>
          {steps.map((label, index) => (
            <Step
              key={label}
              completed={index <= steps.indexOf(selectedRow.crmLeadStatus)}
            >
              <StepButton
                color="inherit"
                onClick={handleStep(index)}
                className="stepperBtn"
              >
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div style={{ marginTop: 20 }}>
          {activeStep === 0 && (
            <NewLeadProfile selectedRow={selectedRow} onClose={onClose} />
          )}
          {activeStep === 3 && (
            <StoreVisit selectedRow={selectedRow} onClose={onClose} />
          )}
          {activeStep === 4 && (
            <DocVerification selectedRow={selectedRow} onClose={onClose} />
          )}
          {activeStep === 5 && (
            <Approvals selectedRow={selectedRow} onClose={onClose} />
          )}
          {activeStep === 6 && (
            <Qualified
              selectedRow={selectedRow}
              areas={areas}
              onClose={onClose}
            />
          )}
          {activeStep === 7 && (
            <Converted selectedRow={selectedRow} onClose={onClose} />
          )}
        </div>
      </Box>
    </>
  );
};

export default EditLeadProfile;
